import UserAdminIndex from '@/views/UserAdmin/UserAdminIndex.vue';
import UserIndex from '@/views/UserAdmin/User/UserIndex.vue';
import UserGroupIndex from '@/views/UserAdmin/UserGroup/UserGroupIndex.vue';
import UserIpIndex from '@/views/UserAdmin/UserIp/UserIpIndex.vue';
import UserProfileIndex from '@/views/UserProfile/UserProfileIndex.vue';
import UserTokensIndex from '@/views/UserAdmin/UserToken/UserTokensIndex.vue';
import UserTokenIndex from '@/views/UserAdmin/UserToken/UserTokenIndex.vue';

export default [
  {
    path: 'users-index',
    name: 'users-index',
    component: UserAdminIndex,
    meta: {
      title: 'User Admin',
    },
    children: [
      {
        path: 'users',
        name: 'users',
        component: UserIndex,
        meta: {
          title: 'Users',
          permission: 'view user-admin::user',
        },
      },
      {
        path: 'groups',
        name: 'groups',
        component: UserGroupIndex,
        meta: {
          title: 'Groups',
          permission: 'view user-admin::role',
        },
      },
      {
        path: 'ips',
        name: 'ips',
        component: UserIpIndex,
        meta: {
          title: 'Allowed Ips',
          permission: 'view user-admin::allowed-ips',
        },
      },
      {
        path: 'api-tokens',
        name: 'api-tokens',
        component: UserTokenIndex,
        meta: {
          title: 'API Tokens',
          permission: 'view app-token',
        },
      },
      {
        path: 'tokens/:id',
        name: 'user-tokens',
        component: UserTokensIndex,
        meta: {
          title: 'Tokens',
          permission: 'view user-token',
        },
      },
    ],
  },
  {
    path: 'user-profile',
    name: 'user-profile',
    component: UserProfileIndex,
    meta: {
      title: 'User Profile',
    },
  },
];
